import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Bem-vinda de volta!"); navigate("/loja"); }
    else setError(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-68px)] grid md:grid-cols-2">
      <div className="hidden md:block relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1548207775-a7676e36f20a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/40 to-ink" />
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <motion.form onSubmit={submit} data-testid="login-form" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-sm">
          <p className="label-caps text-rose mb-3">Entrar</p>
          <h1 className="font-serif-display font-light text-white text-5xl tracking-tight mb-8">Bem-vinda de volta.</h1>
          {error && <p data-testid="login-error" className="text-rose text-sm mb-4 border border-rose/40 px-4 py-2">{error}</p>}
          <label className="label-caps text-white/50 text-[10px]">E-mail</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-surface border border-line focus:border-rose outline-none text-white px-4 py-3 mt-2 mb-5 transition-colors duration-300" />
          <label className="label-caps text-white/50 text-[10px]">Senha</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-surface border border-line focus:border-rose outline-none text-white px-4 py-3 mt-2 mb-8 transition-colors duration-300" />
          <button data-testid="login-submit" disabled={loading} className="w-full bg-rose hover:bg-rose-hover text-ink font-bold py-4 label-caps transition-colors duration-300 disabled:opacity-50">
            {loading ? "Entrando..." : "Entrar"}
          </button>
          <p className="text-white/50 text-sm mt-6">Ainda não tem conta? <Link to="/cadastrar" className="text-rose hover:underline">Cadastre-se</Link></p>
        </motion.form>
      </div>
    </div>
  );
}
